import AppCardDescriptionBlockLayout from './AppCardDescriptionBlockLayout.vue';

export default AppCardDescriptionBlockLayout;



// WEBPACK FOOTER //
// ./src/uikit/layouts/cardlayouts/CardDescriptionBlockLayout/index.ts